import React from 'react'
import { Link } from 'react-router-dom'

function NoArticlesFound({
    text = "",
    articlePath = "/"
}) {
    return (
        <>
            <div className='text-center align-items-center'>
                {text === "orders" ?
                    <p>You haven't {text} anything. Explore our ebooks and start your reading journey! </p>
                    :
                    <p>You haven't {text} anything.Explore our platform and save your favorites here! </p>
                }
                <div className='read-more-btn d-flex align-items-center justify-content-center'>
                    {/* <Link className='edu-btn btn-border btn-small' to={articlePath} >Explore<span><i className="ri-arrow-right-up-line "></i></span></Link> */}
                    <a className='color-primary text-decoration-underline' href={articlePath}>Explore<span><i className="ri-arrow-right-up-line"></i></span></a>
                </div>
            </div>
        </>
    )
}

export default NoArticlesFound
